import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import HeroSlider from "../components/HeroSlider";
import Services from "../components/Services";
import Footer from "../components/Footer";
import Loader from "../components/Loader";

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timeoutId);
  }, []);

  if (loading) return <Loader />;

  return (
    <div dir="rtl" className="text-gray-800">
      <Navbar />
      <main className="max-w-[1700px] mx-auto">
        <HeroSlider />
        <Services />
      </main>
      <Footer />
    </div>
  );
}

